export enum PlasticsManufacturingRatesVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete',
}
